import { render, staticRenderFns } from "./FeedbackReply.vue?vue&type=template&id=15eb5200&scoped=true&"
import script from "./FeedbackReply.vue?vue&type=script&lang=js&"
export * from "./FeedbackReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15eb5200",
  null
  
)

export default component.exports